module.exports = __webpack_public_path__ + "img/yabbr-provided-by.63ce5e42.png";